import { render } from "./ProjectInfo.vue?vue&type=template&id=49f21a78&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-49f21a78"

export default script